'use client';

import { __spreadArray } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import { SELECT_EMPTY_OPTION_ID } from '../Utils/constants.js';
import { usePrevious } from '../Utils/hooks.js';
import { Wrapper, Title, Block, Tag } from './TagSelect.css.js';

var SelectOptionType;
(function (SelectOptionType) {
    SelectOptionType[SelectOptionType["Single"] = 0] = "Single";
    SelectOptionType[SelectOptionType["Multiple"] = 1] = "Multiple";
})(SelectOptionType || (SelectOptionType = {}));
// Empty value may also refer as Select All option
var EMPTY_VALUE_ID = SELECT_EMPTY_OPTION_ID;
/**
 * TagSelect Component
 *
 * @param props
 */
var TagSelect = function (props) {
    var title = props.title, _a = props.options, options = _a === void 0 ? [] : _a, defaultLabel = props.defaultLabel, onSelected = props.onSelected, _b = props.mode, mode = _b === void 0 ? SelectOptionType.Single : _b;
    var propValue = props.value;
    var initValue = propValue || EMPTY_VALUE_ID;
    var prevPropValue = usePrevious(propValue);
    var _c = useState(initValue), value = _c[0], setValue = _c[1];
    useEffect(function () {
        if (propValue !== prevPropValue && propValue !== value) {
            setValue(propValue);
        }
    }, [prevPropValue, propValue, value]);
    var handleOptionSelected = function (selectedOption) {
        var _selectValue = EMPTY_VALUE_ID;
        if (mode === SelectOptionType.Single) {
            _selectValue = selectedOption.id;
        }
        if (mode === SelectOptionType.Multiple) {
            _selectValue = __spreadArray([], value, true);
            if (_selectValue.includes(selectedOption.id)) {
                // remove
                _selectValue = _selectValue.filter(function (_item) { return _item !== selectedOption.id; });
            }
            else {
                _selectValue.push(selectedOption.id);
            }
        }
        setValue(_selectValue);
        onSelected && onSelected(_selectValue);
    };
    var selectOptions = options;
    if (defaultLabel) {
        if (mode === SelectOptionType.Single) {
            selectOptions = __spreadArray([
                {
                    id: EMPTY_VALUE_ID,
                    name: defaultLabel
                }
            ], options, true);
        }
    }
    return (React__default.createElement(Wrapper, null,
        title ? React__default.createElement(Title, null, title) : null,
        React__default.createElement(Block, null, selectOptions.map(function (option) {
            var isSelected = false;
            var _key = "option-".concat(option.id);
            if (mode === SelectOptionType.Single) {
                isSelected = value === option.id;
            }
            else {
                if (typeof value === 'object') {
                    var _arrayValue = value;
                    _key = "".concat(option.id, "-").concat(_arrayValue.join('_'), "-").concat(_arrayValue.length);
                    isSelected = _arrayValue.includes(option.id);
                }
                else {
                    isSelected = value === option.id;
                }
            }
            return (React__default.createElement(Tag, { key: _key, isSelected: isSelected, onClick: function () { return handleOptionSelected(option); }, title: option.name }, option.name));
        }))));
};

export { SelectOptionType, TagSelect as default };
//# sourceMappingURL=index.js.map
